import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import { AppBarButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { Controller, useForm } from "react-hook-form";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { Error } from "../../common/Error";
import { useDispatch } from "react-redux";
import { ReopenApplication } from "../../../domain/ReopenApplication";
import { reopenApplication } from "../../../redux/actions";

export const ReopenButtonAndDialog: React.FC<{ id: string }> = ({ id }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <AppBarButton
        text="Reopen"
        tooltip="Reopen"
        onClick={() => setIsOpen(true)}
      />
      {isOpen && <ReopenDialog id={id} onClose={() => setIsOpen(false)} />}
    </>
  );
};

type ReopenDialogDialogProps = {
  id: string;
  onClose: () => void;
};

const ReopenDialog: React.FC<ReopenDialogDialogProps> = ({ id, onClose }) => {
  const dispatch = useDispatch();

  const { control, errors, handleSubmit } = useForm({});

  const onSubmit = (model: ReopenApplication) => {
    dispatch(reopenApplication(id, model.notes));
    onClose();
  };

  return (
    <>
      <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Reopen Prospective AO</DialogTitle>

        <DialogContent>
          <form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Controller
                  name="notes"
                  rules={{
                    required: true,
                  }}
                  control={control}
                  as={<TextField label="Note" multiline fullWidth rows={4} />}
                />
                {errors.note && <Error>This field is required</Error>}
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
          <Button onClick={handleSubmit(onSubmit)} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
